var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SurveyQuestionElementBase } from "./reactquestion_element";
import { SurveyPanel } from "./panel";
import { ReactQuestionFactory } from "./reactquestion_factory";
import { SurveyActionBar } from "./components/action-bar/action-bar";
import { ReactElementFactory } from "./element-factory";
import { ReactSurveyElement } from "./reactquestion_element";
var SurveyQuestionPanelDynamic = /** @class */ (function (_super) {
    __extends(SurveyQuestionPanelDynamic, _super);
    function SurveyQuestionPanelDynamic(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(SurveyQuestionPanelDynamic.prototype, "question", {
        get: function () {
            return this.questionBase;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionPanelDynamic.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        this.setState({ panelCounter: 0 });
        var self = this;
        this.question.panelCountChangedCallback = function () {
            self.updateQuestionRendering();
        };
        this.question.currentIndexChangedCallback = function () {
            self.updateQuestionRendering();
        };
        this.question.renderModeChangedCallback = function () {
            self.updateQuestionRendering();
        };
    };
    SurveyQuestionPanelDynamic.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        this.question.panelCountChangedCallback = function () { };
        this.question.currentIndexChangedCallback = function () { };
        this.question.renderModeChangedCallback = function () { };
    };
    SurveyQuestionPanelDynamic.prototype.updateQuestionRendering = function () {
        this.setState({
            panelCounter: this.state ? this.state.panelCounter + 1 : 1,
        });
    };
    SurveyQuestionPanelDynamic.prototype.renderElement = function () {
        var _this = this;
        var panels = [];
        var cssClasses = this.question.cssClasses;
        this.question.renderedPanels.forEach(function (panel, index) {
            panels.push(React.createElement(SurveyQuestionPanelDynamicItem, { key: panel.id, element: panel, question: _this.question, index: index, cssClasses: cssClasses, isDisplayMode: _this.isDisplayMode, creator: _this.creator }));
        });
        var rangeTop = this.question.isRangeShowing && this.question.isProgressTopShowing
            ? this.renderRange()
            : null;
        var navV2 = this.renderNavigatorV2();
        var noEntriesPlaceholder = this.renderPlaceholder(cssClasses);
        return (React.createElement("div", { className: cssClasses.root },
            this.question.hasTabbedMenu ? React.createElement("div", { className: this.question.getTabsContainerCss() },
                React.createElement(SurveyActionBar, { model: this.question.tabbedMenu })) : null,
            noEntriesPlaceholder,
            rangeTop,
            React.createElement("div", { className: this.question.cssClasses.panelsContainer }, panels),
            navV2));
    };
    SurveyQuestionPanelDynamic.prototype.renderRange = function () {
        return (React.createElement("div", { className: this.question.cssClasses.progress },
            React.createElement("div", { className: this.question.cssClasses.progressBar, style: { width: this.question.progress }, role: "progressbar", "aria-label": this.question.progressBarAriaLabel })));
    };
    SurveyQuestionPanelDynamic.prototype.renderAddRowButton = function () {
        return ReactElementFactory.Instance.createElement("sv-paneldynamic-add-btn", {
            data: { question: this.question }
        });
    };
    SurveyQuestionPanelDynamic.prototype.renderNavigatorV2 = function () {
        if (!this.question.showNavigation)
            return null;
        var range = this.question.isRangeShowing && this.question.isProgressBottomShowing ? this.renderRange() : null;
        return (React.createElement("div", { className: this.question.cssClasses.footer },
            React.createElement("hr", { className: this.question.cssClasses.separator }),
            range,
            this.question.showFooterToolbar ? (React.createElement("div", { className: this.question.cssClasses.footerButtonsContainer },
                React.createElement(SurveyActionBar, { model: this.question.footerToolbar }))) : null));
    };
    SurveyQuestionPanelDynamic.prototype.renderPlaceholder = function (cssClasses) {
        if (this.question.getShowNoEntriesPlaceholder())
            return ReactElementFactory.Instance.createElement("sv-placeholder-paneldynamic", { cssClasses: cssClasses, question: this.question });
        return null;
    };
    return SurveyQuestionPanelDynamic;
}(SurveyQuestionElementBase));
export { SurveyQuestionPanelDynamic };
var SurveyQuestionPanelDynamicItem = /** @class */ (function (_super) {
    __extends(SurveyQuestionPanelDynamicItem, _super);
    function SurveyQuestionPanelDynamicItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SurveyQuestionPanelDynamicItem.prototype, "question", {
        get: function () {
            return this.props.question;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionPanelDynamicItem.prototype, "index", {
        get: function () {
            return this.props.index;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionPanelDynamicItem.prototype.getSurvey = function () {
        return !!this.question ? this.question.survey : null;
    };
    SurveyQuestionPanelDynamicItem.prototype.getCss = function () {
        var survey = this.getSurvey();
        return !!survey ? survey.getCss() : {};
    };
    SurveyQuestionPanelDynamicItem.prototype.render = function () {
        var panel = _super.prototype.render.call(this);
        var removeButton = this.renderButton();
        var separator = this.question.showSeparator(this.index) ?
            (React.createElement("hr", { className: this.question.cssClasses.separator })) : null;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: this.question.getPanelWrapperCss(this.panel) },
                panel,
                removeButton),
            separator));
    };
    SurveyQuestionPanelDynamicItem.prototype.renderButton = function () {
        if (!this.question.canRenderRemovePanelOnRight(this.panel))
            return null;
        return ReactElementFactory.Instance.createElement("sv-paneldynamic-remove-btn", {
            data: { question: this.question, panel: this.panel }
        });
    };
    return SurveyQuestionPanelDynamicItem;
}(SurveyPanel));
export { SurveyQuestionPanelDynamicItem };
ReactQuestionFactory.Instance.registerQuestion("paneldynamic", function (props) {
    return React.createElement(SurveyQuestionPanelDynamic, props);
});
var SurveyQuestionPanelDynamicPlaceholder = /** @class */ (function (_super) {
    __extends(SurveyQuestionPanelDynamicPlaceholder, _super);
    function SurveyQuestionPanelDynamicPlaceholder(props) {
        return _super.call(this, props) || this;
    }
    SurveyQuestionPanelDynamicPlaceholder.prototype.renderElement = function () {
        var cssClasses = this.props.cssClasses;
        var question = this.props.question;
        return (React.createElement("div", { className: cssClasses.noEntriesPlaceholder },
            React.createElement("span", null, this.renderLocString(question.locNoEntriesText)),
            this.renderAddRowButton(question)));
    };
    SurveyQuestionPanelDynamicPlaceholder.prototype.renderAddRowButton = function (question) {
        return ReactElementFactory.Instance.createElement("sv-paneldynamic-add-btn", {
            data: { question: question }
        });
    };
    return SurveyQuestionPanelDynamicPlaceholder;
}(ReactSurveyElement));
export { SurveyQuestionPanelDynamicPlaceholder };
ReactElementFactory.Instance.registerElement("sv-placeholder-paneldynamic", function (props) { return React.createElement(SurveyQuestionPanelDynamicPlaceholder, props); });
